import {MyLookieroRepository} from '@domain/model/Account/MyLookiero/MyLookieroRepository';
import {CalendarDates} from '@domain/model/Account/MyLookiero/domain/model';
import {Country} from '@domain/model/Site/Locale';

const GetCalendarDates =
  (repository: MyLookieroRepository): ((country: Country, userId: string) => Promise<CalendarDates>) =>
  (country: Country, userId: string): Promise<CalendarDates> =>
    repository.getCalendarDates(country, userId);

export {GetCalendarDates};
